module.exports = __webpack_public_path__ + "static/media/color.ad899c81.svg";